module.exports = __webpack_public_path__ + "static/media/ic-contact-mail.0af7a7c3.svg";